import { actionCreator } from '@blink/components/src/utils';

import {
    GET_VAULTS,
    GET_LINKED_POOLS,
    SET_VAULTS,
    SET_VAULTS_LOADING_FALSE,
    SET_LINKED_POOLS,
} from './constants';

import { Vault } from '@/shared/api/vault';

export const getVaultsAction = (payload: { withoutCache?: boolean }) =>
    actionCreator(GET_VAULTS, payload);

export const setVaultsAction = (payload: Vault[]) => actionCreator(SET_VAULTS, payload);

export const setVaultsLoadingFalseAction = () => actionCreator(SET_VAULTS_LOADING_FALSE);

export const getVaultPools = (payload: {
    vaultAddress: string;
    marginAccountAddress: string;
    withoutCache?: boolean;
}) => actionCreator(GET_LINKED_POOLS, payload);

export const setVaultPools = (payload: { vaultAddress: string; linkedPools: Vault[] }) =>
    actionCreator(SET_LINKED_POOLS, payload);
